import * as WebBrowser from 'expo-web-browser';
import type { WebBrowserOpenOptions } from 'expo-web-browser';
import { Linking } from 'react-native';

export default async function openBrowserAsync(
  url: string,
  browserParams?: WebBrowserOpenOptions | undefined
) {
  try {
    return await WebBrowser.openBrowserAsync(url, browserParams);
  } catch (error) {
    if (await Linking.canOpenURL(url)) {
      Linking.openURL(url);
    }
  }
}
